// ========= GLOBAL CONSTANTS ===========
var Cookies = require('js-cookie');

// let mobile_menu;
let width = $(window).width();
let device_state = (width >= 992) ? 'desktop' : (width >= 576) ? 'tablet' : 'mobile';
// ========= GLOBAL CONSTANTS ===========

window.checkIfExists = ($item) => {
  const item = $($item).length;
  return (item > 0);
}

window.cityId = () => {
  return $('#city_id').val();
}

window.loadjs = (script_filename) => {
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', script_filename);
    script.setAttribute('id', 'script_id');

    script_id = document.getElementById('script_id');
    if(script_id){
        document.getElementsByTagName('head')[0].removeChild(script_id);
    }
    document.getElementsByTagName('head')[0].appendChild(script);
}

// window.productColorChange = () => {
//   var color_id = $('#product-form .color-select option:selected').val();
//   var color_text = $('#product-form .color-select option:selected').data('title');

//   if (color_id > 0) {
//     $('#quick-order-form .color-text').text(color_text).removeClass('color-dark-red');
//   }else{
//     $('#quick-order-form .color-text').text(color_text).addClass('color-dark-red');
//   }

//   $('#quick-order-form .size-text').text($('#product-form .size-select').data('title')).addClass('color-dark-red');

//   var language = $('#product-form').data('language');
//   var product_id = $('#product-form input[name=product_id]').val();
//   var csrf = $('#product-form input[name=_token]').val();

//   $('#quick-order-form #color_id').val('');
//   $('#quick-order-form #size_id').val('');

//   $(document).on('change', '#product-form .size-select', function(){

//     $('#quick-order-form #color_id').val(color_id);
//     var size_id = $('#product-form .size-select option:selected').val();
//     var size_text = $('#product-form .size-select option:selected').data('title');

//     if (size_id > 0) {
//       $('#quick-order-form .size-text').text(size_text).removeClass('color-dark-red');
//     }else{
//       $('#quick-order-form .size-text').text(size_text).addClass('color-dark-red');
//     }

//     $('#quick-order-form #size_id').val(size_id);

//     if ($(this).data('delivery') != '') {
//       $('.delivery-text').text($('#product-form .size-select option:selected').data('delivery'))

//     }
//   })

//   if (color_id != '' && color_id > 0) {
//     var data = {
//       product_id: product_id,
//       language: language,
//       color_id: color_id,
//       _token: csrf
//     }
//     $.ajax({
//       url: '/'+language+'/get-product-sizes',
//       type: 'post',
//       data: data,
//       dataType: 'json',
//       success: function(data){
//         if (data.length > 0) {
//           var size_select_title = $('.size-select').data('title');

//           $('#product-form .size-select').html('<option value="" data-title="Изберете размер">- '+size_select_title+' -</option>').prop('disabled', false);
//           $.each(data, function(key, value){
//             const size_option = `<option value="${value.id}" data-title="${value.title}" data-delivery="${value.delivery}" data-qty="${value.qty}">${value.title}</option>`;

//             $('#product-form .size-select').append(size_option);
//           });
//         }
//       }
//     });
//     // $('.splide__slide').trigger('click');
//   }else{
//     var color_select_title = $('.size-select').data('color-title');
//     $('#product-form .size-select').html('<option value="">- '+color_select_title+' -</option>').prop('disabled', true);
//   }
// }


window.productColorChangeNew = () => {
  var color_id = $('#product-form .color-select option:selected').val();
  var color_text = $('#product-form .color-select option:selected').data('title');



  var language = $('#product-form').data('language');
  var product_id = $('#product-form input[name=product_id]').val();
  var csrf = $('#product-form input[name=_token]').val();


  $(document).on('change', '#product-form .size-check', function(){
    if ($(this).data('delivery') != '') {
      $('.delivery-text').text($('#product-form .size-check:checked').data('delivery'));
    }
  })

  if (color_id != '' && color_id > 0) {
    var data = {
      product_id: product_id,
      language: language,
      color_id: color_id,
      _token: csrf
    }
    $.ajax({
      url: '/'+language+'/get-product-sizes',
      type: 'post',
      data: data,
      dataType: 'json',
      success: function(data){
        if (data.length > 0) {
          var size_select_title = $('.size-select').data('title');

          $('#product-form .size-checkbox-wrapper').html('');
          $.each(data, function(key, value){
            let checked_size = '';
            if(value.id == 1){
                checked_size = 'checked';
            }
            else{
                checked_size = '';
            }
            const size_option = `<label for="size-${value.id}" class="size-label">
            <input class="size-check" name="size_id" type="radio" data-title="${value.title}" data-delivery="${value.delivery}" data-qty="${value.qty}" id="size-${value.id}" value="${value.id}" ${checked_size} /> ${value.title}
            </label`;

            $('#product-form .size-checkbox-wrapper').append(size_option);
          });
        }
      }
    });
    // $('.splide__slide').trigger('click');
  }else{
    var color_select_title = $('.color-select option:selected').data('title');
    $('#product-form .size-checkbox-wrapper').html(`<div class="alert alert-warning">${color_select_title}</div>`);
  }
}

window.photoColorChange = (splide) => {
  var color_id = $('#product-form .color-select option:selected').val();
  var index = $('.splide__list li').index($('.product-photo-'+color_id + ':first'));
  // var slide = splide.getAt(2);
  splide.go(index);
  // splide.go(3);
}

window.cardPaymentDiscount = () => {
    var subtotal = parseFloat($('.subtotal').data('price'), 10);
    var shipping = parseFloat($('.shipping-price').data('shipping'));
    var discount_percent = 5;
    var total_after_discount = parseFloat((subtotal - ((subtotal / 100) * discount_percent)).toFixed(2));
    var currency = $('.total-price').data('currency');
    var symbolPlace = $('.total-price').data('symbolplace');

    console.log(total_after_discount);

    if($('.checkout input[name=payment]:checked').val() == 2) {
      $('.price-discount').removeClass('d-none');
      $('.discount-percent').text('-'+discount_percent + '%');

      if (symbolPlace == 1) {
        $('.total-price').text(currency + '' + parseFloat(total_after_discount + shipping).toFixed(2));
      }else{
        $('.total-price').text(parseFloat(total_after_discount + shipping).toFixed(2) + ' ' + currency);
      }

    }else{
      $('.price-discount').addClass('d-none');
      $('.discount-percent').text('');

      if (symbolPlace == 1) {
        $('.total-price').text(currency + '' + parseFloat(subtotal + shipping).toFixed(2));
      }else{
        $('.total-price').text(parseFloat(subtotal + shipping).toFixed(2) + ' ' + currency);
      }
    }
}


window.checkoutLeasingTable = () =>{
  let val = $('.checkout input[name=payment]:checked').val();

  if(val == 3){
    $('.checkout-leasing').removeClass('d-none');
  }else{
    $('.checkout-leasing').addClass('d-none');
  }
}

window.showLeasingTotals = () => {
  let payment = $('input[name=payment]:checked').val();
  let leasingMonthlyPayment = $('.select-leasing-table tr.leasingrow').data('leasing-month-sum');
  let leasingMonths = $('.select-leasing-table tr.leasingrow').data('leasing-months');
  let leasingTotalSum = $('.select-leasing-table tr.leasingrow').data('leasing-total');

  if(payment == 3){
    $('.leasing-payment').removeClass('d-none');
    $('.leasing-monthly-payment').text(leasingMonthlyPayment);
    $('.leasing-months').text(leasingMonths);
    $('.leasing-total-price').text(leasingTotalSum).removeClass('d-none');
    $('.total-price').addClass('d-none');
  }else{
    $('.leasing-payment').addClass('d-none');
    $('.leasing-total-price').addClass('d-none');
    $('.total-price').removeClass('d-none');
  }
}


window.quickOrderColorChange = () => {
  var color_id = $('#quick-order-form .color-select option:selected').val();
  var language = $('#quick-order-form').data('language');
  var product_id = $('#quick-order-form input[name=product_id]').val();
  var csrf = $('#quick-order-form input[name=_token]').val();


  if (color_id != '' && color_id > 0) {
    var data = {
      product_id: product_id,
      language: language,
      color_id: color_id,
      _token: csrf
    }
    $.ajax({
      url: '/'+language+'/get-product-sizes',
      type: 'post',
      data: data,
      dataType: 'json',
      success: function(data){
        if (data.length > 0) {
          $('#quick-order-form .size-select').html('<option value="">- Избери -</option>').prop('disabled', false);
          $.each(data, function(key, value){
            const size_option = `<option value="${value.id}">${value.title}</option>`;

            $('#quick-order-form .size-select').append(size_option);
          });
        }
      }
    });
    $('.splide__slide').trigger('click');
  }else{
    $('#quick-order-form .size-select').html('<option value="">- Моля изберете първо цвят -</option>').prop('disabled', true);
  }
}

window.arraySearch = (arr,val) => {
    for (var i=0; i<arr.length; i++)
        if (arr[i] === val)
            return i;
    return false;
  }


  // Self-invoking function
  if (checkIfExists('.products-page')) {
    var gridCol;

    (window.checkGrid = ($) => {
      var cookieGrid = Cookies.get('grid');
      gridCol = $('#'+cookieGrid).data('col');
      if (gridCol != '' && gridCol != undefined) $('#products-list div').attr('class', gridCol + ' prod-col');
      if(cookieGrid == 'grid-four') $('#products-list').attr('class', 'row product-grid-4')
      if(cookieGrid == 'grid-five') $('#products-list').attr('class', 'row product-grid-5')
      if(cookieGrid == 'grid-six') $('#products-list').attr('class', 'row product-grid-6')
    })(jQuery)
  }

//   window.initScrollbar = ($) => {
//     Scrollbar.initAll({
//       alwaysShowTracks: true
//     });
//
//   }
// initScrollbar();
window.checkBackToTop = ($item, $base) => {
  if (width < 768 && $(window).scrollTop() > 200) {
    $('.back-to-top').fadeIn('fast');
  } else {
    // If item exists
    if (checkIfExists($item)) {
      // And item (ex. Products box) height is more than base (ex. Filers box) then show Back to top Button
      if ($($item).innerHeight() > $($base).innerHeight()) {
        $('.back-to-top').fadeIn('fast');
      }
    }
  }

}

window.backToTop = ($item, $offset = 100, $time = 500) => {
  $('.back-to-top').click(function (e) {
    e.preventDefault()
    $('html, body').animate({
      scrollTop: $($item).offset().top - $offset
    }, $time);
  })
}

window.showModal = function($modal, $modalUrl) {
    $($modal).find('.modal-content').load($modalUrl);
}

window.removeOpenedWindows = () => {
  // Closing all opened windows/boxes such as Cart, Search Form on mobile etc..
  // $('header .language').dropdown('hide');
  $('#filters').removeClass('opened-filter');
  $('.quick-cart-items').removeClass('cart-active');
  $('#product-leasing').removeClass('open');
  $('.overlay').fadeOut('fast');
  $('.overlay').css('z-index', '');
  $.sidr('close', 'sidr-main');
   $.sidr('close', 'sidr-right');
  $('html, body').removeClass('overflow-hidden');
  if ($(window).width() < 992) {
    $('header .search-form').stop().slideUp('fast');
  } else {
    $('header .search-form').stop().slideDown('fast');
  }
  setTimeout(function () {
    $('.mm-slideout').css('z-index', '');
  }, 100)
}

window.hideOnSubmit = ($button, $holder = '', $hasErr = false) => {
  // Showing wait button on form submit

  // $button -- The submit button to be hidden
  // $holder -- In case there are 2 forms in a single page
  // $hasErr --  If there's an error, show back the submit button (true/false)

  if ($hasErr) {
    $(`${$holder} .btn-wait`).addClass('d-none');
    $($button).removeClass('d-none');
    return
  }
  $($button).addClass('d-none');
  $(`${$holder} .btn-wait`).removeClass('d-none');
}

window.showSelectedSize = ($val = '') => {
  if ($('.custom-select-vmz.select-size select').val() != '') {

    let value = $('.custom-select-vmz.select-size select').val()
    if ($val != '') {
      value = $val
    }
    $.ajax({
      url: '/ajax-get-size/' + value,
      type: 'get',
      dataType: 'html',
      success: function(data){
        $('.product-detail .sizes-table').html(data);
        $('.product-detail .sizes-table').slideDown('fast');
      },
      errorHandler: function (err) {
        console.log(err)
      }
    });
  } else {
    $('.product-detail .sizes-table').slideUp('fast');
  }
}
if ($('.custom-select-vmz.select-size select').length > 0) {
  showSelectedSize()
}

window.productSyncSelected = ($val, $select) => {
  // Sync selected color/size with quick order in product detail

  // $select -- The select(size/color) to be changed with the $val

  if($val != undefined) {
    if ($val == '') {
      $('.product-detail .custom-select-vmz.' + $select + ' select').val('')
    } else {
      $('.product-detail .custom-select-vmz.' + $select + ' select').val($val)
    }
    showSelectedSize($val)
  }

}

window.updateProductQuantity = ($target) => {
  let current_val = $('.qty-wrapper #qty').val();
  ($($target.currentTarget).hasClass('minus-btn')) ? ((current_val != 1) && (current_val--)) : current_val++
  $('.qty-wrapper #qty').val(current_val)
}

window.formatNumber = (num) => {
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


window.changeShippingTo = () => {
  if ($('.shipping-info-box input[name=shipping_to]:checked').val() == 2) {
        // Офис
        $('.delivery-address input#address').slideUp('fast').addClass('ignore');
        $('.delivery-address input#no').slideUp('fast').addClass('ignore');
        $('#address-label').addClass('d-none');
        $('#address-no-label').addClass('d-none');
        $('#office-label').removeClass('d-none');
        $('#office').removeClass('d-none').removeClass('ignore');

        $('.delivery-address .dropdown.bootstrap-select').slideDown('fast');
        $('#office_select').removeClass('ignore');
        $('#block-info').addClass('d-none');
        $('#address-error').html('');
        $('.office-address-wrapper').removeClass('d-none');
        $('.street-address-wrapper').addClass('d-none');
        $('.delivery-address').removeClass('d-none');

        $('label[for="shipping_to_address"]').removeClass('active');
          $('label[for="shipping_to_office"]').addClass('active');
        // Cookies.set('shipping_to', '1', {expires: inFifteenMinutes, 'samesite': 'strict'});
        // Куриер - до офис  - може ЕКОНТ и СПИДИ
          $('.courier-box .radio-econt').prop('checked', true).prop('disabled', false);
          $('.courier-box label[for=courier_econt]').addClass('active').removeClass('disabled');
          // $('.courier-box .radio-speedy').prop('disabled', false).prop('checked', true);
          // $('.courier-box label[for=courier_speedy]').removeClass('disabled').addClass('active');

          // $('.courier-box .radio-euroshipment').prop('disabled', true);
          // $('.courier-box label[for=courier_euroshipment]').addClass('disabled');
      } else if ($('.shipping-info-box input[name=shipping_to]:checked').val() == 1) {
        // Адрес
        $('.delivery-address input#address').slideDown('fast').removeClass('ignore');
        $('.delivery-address input#no').slideDown('fast').removeClass('ignore');
        $('#address-label').removeClass('d-none');
        $('#address-no-label').removeClass('d-none');
        $('#office-label').addClass('d-none');
        $('#office').addClass('d-none').addClass('ignore');

        $('.delivery-address .dropdown.bootstrap-select').slideUp('fast');
        $('#office_select').addClass('ignore');
        $('#block-info').removeClass('d-none');
        $('#office-error').html('');
        $('.office-address-wrapper').addClass('d-none');
        $('.street-address-wrapper').removeClass('d-none');
        $('.delivery-address').removeClass('d-none');
        // Cookies.set('shipping_to', '0', {expires: inFifteenMinutes, 'samesite': 'strict'});

        $('label[for="shipping_to_address"]').addClass('active');
          $('label[for="shipping_to_office"]').removeClass('active');

        // Куриер - до адрес  - може само Euroshipment
        $('.courier-box .radio-econt').prop('checked', true).prop('disabled', false);
          $('.courier-box label[for=courier_econt]').addClass('active').removeClass('disabled');
          
          // $('.courier-box .radio-speedy').prop('checked', false);
          // $('.courier-box label[for=courier_speedy]').addClass('disabled').removeClass('active');
          // $('.courier-box .radio-econt').prop('checked', false).prop('disabled', true);
          // $('.courier-box label[for=courier_econt]').addClass('disabled').removeClass('active');

          // $('.courier-box .radio-euroshipment').prop('disabled', false).prop('checked', true);
          // $('.courier-box label[for=courier_euroshipment]').removeClass('disabled').addClass('active');

      }else{
        $('.delivery-address').toggleClass('d-none');
      }
}
